import { useState } from "react";

/**
 * design to maintain the loading state for loading overlay
 *
 * @param initialLoading
 *
 * @author rajkumar rathod
 */
export const useLoading = (
  initialLoading?: boolean
): [boolean, (v: boolean) => void] => {
  const [isLoading, setIsLoading] = useState<boolean>(initialLoading ?? false);
  /**
   *@case  this leads the case while develop may forget to false this isLoading state:
   * - it should stop itSelf automatically
   *@see __apiTimeOut should be in milliSeconds
   * - setting it default to 10000 milliSeconds
   */
  const [__apiTimeOut, __setApiTimeOut] = useState<number>(10000);
  /**
   *@warn  __apiTimeOut should match the `B.E api's TimeOut`
   */

  const setLoading = (loading: boolean) => {
    setIsLoading(loading);
    setTimeout(() => setIsLoading(false), __apiTimeOut);
  };

  return [isLoading, setLoading];
};
